import React from 'react';

function ErrorPage() {
    return (
        <h1 style={{color: 'white'}}>Qualcosa è andato storto. Per favore ricaricare la pagina. Se il problema persiste contattare gli amministratori.</h1>
    );
}

export default ErrorPage;
